import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { readBundledData } from "@faire/retailer-visitor-shared/lib/bundledData";
import { getBrand } from "@faire/retailer-visitor-shared/serialized-data/getBrand";
import { cachingApi } from "@faire/web--source/common/cachingApi";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import fetchBrand from "@faire/web-api--source/api/brand/brandToken/get";
import memoizee from "memoizee";
/**
 * @deprecated prefer to use `useBrandStore` or `withStores` instead
 */ export var BrandStore = /*#__PURE__*/ function() {
    "use strict";
    function BrandStore() {
        _class_call_check(this, BrandStore);
        var _this = this;
        this.getPrefetchedBrand = memoizee(function() {
            return readBundledData("brand");
        }, {
            maxAge: 1000 * 60 * 5
        });
        this.cachedFetchBrand = cachingApi(/*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(token) {
                var _getBrand, prefetched;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (((_getBrand = getBrand()) === null || _getBrand === void 0 ? void 0 : _getBrand.token) === token) {
                                return [
                                    2,
                                    getBrand()
                                ];
                            }
                            prefetched = _this.getPrefetchedBrand();
                            if ((prefetched === null || prefetched === void 0 ? void 0 : prefetched.token) === token) {
                                return [
                                    2,
                                    prefetched
                                ];
                            }
                            return [
                                4,
                                fetchBrand(token)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(token) {
                return _ref.apply(this, arguments);
            };
        }());
        this.getBrand = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(brandToken) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!brandToken) {
                                return [
                                    2,
                                    undefined
                                ];
                            }
                            return [
                                4,
                                _this.cachedFetchBrand(brandToken)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(brandToken) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    _create_class(BrandStore, [
        {
            key: "prefetchedFullBrand",
            get: function get() {
                return this.getPrefetchedBrand();
            }
        }
    ]);
    return BrandStore;
}();
BrandStore.get = singletonGetter(BrandStore);
export var useBrandStore = createStoreHook(BrandStore);
